import { FC } from "react";

const LinkedinLogo: FC<{ size?: number }> = ({ size = 32 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M26.9099 3.19971H5.08949C4.58829 3.19971 4.10761 3.39881 3.75321 3.75321C3.39881 4.10761 3.19971 4.58829 3.19971 5.08949V26.9099C3.19971 27.4111 3.39881 27.8918 3.75321 28.2462C4.10761 28.6006 4.58829 28.7997 5.08949 28.7997H26.9099C27.4111 28.7997 27.8918 28.6006 28.2462 28.2462C28.6006 27.8918 28.7997 27.4111 28.7997 26.9099V5.08949C28.7997 4.58829 28.6006 4.10761 28.2462 3.75321C27.8918 3.39881 27.4111 3.19971 26.9099 3.19971ZM10.8299 25.0077H6.98104V12.7819H10.8299V25.0077ZM8.90282 11.0877C8.46623 11.0852 8.04015 10.9535 7.67836 10.7091C7.31656 10.4648 7.03527 10.1187 6.86998 9.71458C6.70468 9.31048 6.6628 8.86647 6.74961 8.43859C6.83642 8.01071 7.04803 7.61814 7.35774 7.31041C7.66745 7.00268 8.06138 6.79359 8.48981 6.70953C8.91823 6.62547 9.36196 6.67021 9.76499 6.83809C10.168 7.00598 10.5123 7.28949 10.7543 7.65284C10.9964 8.0162 11.1254 8.44311 11.125 8.87971C11.1292 9.17201 11.0744 9.46215 10.964 9.73283C10.8536 10.0035 10.6898 10.2492 10.4824 10.4552C10.2751 10.6613 10.0283 10.8235 9.75696 10.9321C9.48557 11.0408 9.19509 11.0937 8.90282 11.0877ZM25.0166 25.0184H21.1695V18.3393C21.1695 16.3695 20.3322 15.7615 19.2513 15.7615C18.1099 15.7615 16.9899 16.6219 16.9899 18.389V25.0184H13.141V12.7908H16.8424V14.485H16.8922C17.2637 13.733 18.565 12.4477 20.5508 12.4477C22.6984 12.4477 25.0184 13.7224 25.0184 17.4557L25.0166 25.0184Z"
        fill="#0A66C2"
      />
    </svg>
  );
};

export default LinkedinLogo;
